import React, { useState } from "react";
import Styles from "../assets/css/layouts/navbar.module.scss";
import { FaBars, FaBell, FaUserCircle, FaCog, FaSignOutAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Profile from "../assets/images/Admin/admin_profile.png";
import { useDispatch, useSelector } from "react-redux";
import { sidebarOff, sidebarOn } from "../features/navbar/toggleSlice";

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const loginAdminInfo = JSON.parse(localStorage.getItem("user_data"))
  const navigate = useNavigate(); 

  const toggleValue = useSelector(state => state.toggle.toggle);
  const dispatch = useDispatch();

  const handleProfileClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const logout = () => {
    localStorage.removeItem("user_data");
    localStorage.removeItem("token");
    navigate('/login');
  }

  return (
    <div className={`${Styles.navbar} ${toggleValue ? Styles.active : ""}`}>
      <div className={`${Styles.nav} ${Styles.container}`}>
        <div className={`${Styles.toggle}`}>
          <FaBars onClick={() => toggleValue ? dispatch(sidebarOn()) : dispatch(sidebarOff())}/>
        </div>

        <div className={`${Styles.menu}`}>
          <div
            className={`${Styles.profile} ${dropdownOpen ? Styles.open : ""}`}
            onClick={handleProfileClick}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <div className={`${Styles.profile_photo_name}`}>
              <p>Admin</p>
              {/* <p>{(loginAdminInfo?.name === "" || loginAdminInfo === null) ? "Undefind" : loginAdminInfo.name}</p> */}
              {/* <p>Jainesh Patel</p> */}
              <div className={`${Styles.user_logo}`}>
                <img src={Profile} alt="not supported" />
              </div>
            </div>
            <div className={`${Styles.profile_dropdown}`}>
              {/* <Link to="#">
                <FaUserCircle /> Profile
              </Link> */}
              <Link to="/business">
                <FaCog /> Setting
              </Link>
              <hr />
              <Link onClick={logout}>
                <FaSignOutAlt /> Logout
              </Link>
            </div>
          </div>

          {/* <div className={`${Styles.notification}`}>
            <FaBell />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
